<template>
    <b-card no-body>
        <b-tabs card>
            <b-tab :title="title" active>
                <b-card-text>
                    <b-form @submit.stop.prevent="onSubmit">
                        <b-form-row>
                            <b-col
                                v-for="(d_item, i) in validDataItems"
                                :key="i + 'data'"
                                :cols="d_item.cols"
                            >
                                <b-form-group
                                    :id="d_item.field"
                                    :label="
                                        getLabel(d_item.field) +
                                        (d_item.required ? '*' : '')
                                    "
                                    :label-for="'input-' + d_item.field"
                                    label-cols="3"
                                    v-if="checkVisibility(d_item)"
                                >
                                    <master-item-type-ahead
                                        v-if="d_item.field === 'container_id'"
                                        v-model="model[d_item.field]"
                                        :is-product-only="true"
                                        :disabled="isView"
                                    ></master-item-type-ahead>
                                    <selection-values
                                        v-else-if="
                                            d_item.field === 'value_selections'
                                        "
                                        :id="'input-' + d_item.field"
                                        v-model="model[d_item.field]"
                                        :required="d_item.required"
                                        :name="'input-' + d_item.field"
                                        :disabled="isView"
                                    >
                                    </selection-values>

                                    <default-value
                                        v-else-if="
                                            d_item.field === 'default_value'
                                        "
                                        :is-selection-value-type="
                                            !!model.is_selection_value_type
                                        "
                                        :values="model.value_selections"
                                        :id="'input-' + d_item.field"
                                        v-model="model[d_item.field]"
                                        :required="d_item.required"
                                        :disabled="isView"
                                        :min="model.value_min"
                                        :max="model.value_max"
                                    />

                                    <b-form-checkbox
                                        v-else-if="d_item.type === 'boolean'"
                                        :id="'input-' + d_item.field"
                                        v-model="model[d_item.field]"
                                        :required="d_item.required"
                                        :name="'input-' + d_item.field"
                                        :value="1"
                                        :unchecked-value="0"
                                        :disabled="isView"
                                    >
                                    </b-form-checkbox>

                                    <b-form-select
                                        v-else-if="d_item.type === 'select'"
                                        :id="'input-' + d_item.field"
                                        v-model="model[d_item.field]"
                                        :required="d_item.required"
                                        :options="getOptions(d_item.field)"
                                        :disabled="isView"
                                    >
                                        <template #first>
                                            <b-form-select-option
                                                :value="null"
                                                disabled
                                                >{{
                                                    'Select ' +
                                                    getLabel(d_item.field)
                                                }}</b-form-select-option
                                            >
                                        </template>
                                    </b-form-select>
                                    <b-form-input
                                        v-else
                                        :disabled="isView"
                                        :type="d_item.type"
                                        :id="'input-' + d_item.field"
                                        v-model="model[d_item.field]"
                                        :required="d_item.required"
                                        :placeholder="
                                            'Enter ' + getLabel(d_item.field)
                                        "
                                        trim
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-form-row>

                        <b-form-row>
                            <b-col offset="5">
                                <b-button-group size="sm">
                                    <b-button
                                        variant="secondary"
                                        :disabled="!!submitting"
                                        @click="cancel()"
                                        >Cancel</b-button
                                    >
                                    <b-button
                                        v-if="
                                            !!model.id &&
                                            (hasPermissionUpdate ||
                                                hasPermissionDelete)
                                        "
                                        variant="primary"
                                        :disabled="!!submitting"
                                        @click="isView = !isView"
                                        >{{
                                            isView ? 'Edit Item' : 'View Item'
                                        }}</b-button
                                    >
                                    <b-button
                                        v-if="!model.id && hasPermissionCreate"
                                        variant="primary"
                                        :disabled="!!submitting"
                                        type="submit"
                                    >
                                        <b-spinner
                                            v-show="submitting"
                                            label="Spinning"
                                        ></b-spinner>
                                        Create Item
                                    </b-button>

                                    <b-button
                                        v-if="
                                            !!model.id &&
                                            hasPermissionUpdate &&
                                            !isView
                                        "
                                        variant="primary"
                                        :disabled="!!submitting"
                                        type="submit"
                                    >
                                        <b-spinner
                                            v-show="submitting"
                                            label="Spinning"
                                        ></b-spinner>
                                        Update Item
                                    </b-button>

                                    <b-button
                                        v-if="
                                            !!model.id &&
                                            hasPermissionDelete &&
                                            isView
                                        "
                                        @click="deleteMasterItem()"
                                        variant="warning"
                                    >
                                        Delete Item
                                    </b-button>
                                </b-button-group>
                            </b-col>
                        </b-form-row>
                    </b-form>
                </b-card-text>
            </b-tab>
            <b-tab title="Inventory">
                <b-card-body>
                    <ItemInventory :master_item_id="id" />
                </b-card-body>
            </b-tab>
        </b-tabs>
    </b-card>
</template>
<script>
const dataItems = [
    { field: 'name', type: 'text', required: true, cols: '12' },
    {
        field: 'ext_reference_code',
        type: 'text',
        required: true,
        cols: '12',
    },
    {
        field: 'order_item_type_id',
        type: 'select',
        required: true,
        cols: '12',
    },
    {
        field: 'size',
        type: 'number',
        required: false,
        cols: '12',
    },
    {
        field: 'container_id',
        type: 'custom',
        required: false,
        cols: '12',
    },
    { field: 'description', type: 'text', required: true, cols: '12' },
    { field: 'vendor_id', type: 'select', required: true, cols: '12' },
    { field: 'uom', type: 'text', required: true, cols: '12' },
    {
        field: 'selling_price',
        type: 'number',
        required: false,
        cols: '12',
    },

    {
        field: 'is_selection_value_type',
        type: 'boolean',
        required: false,
        cols: '12',
    },

    { field: 'value_name', type: 'text', required: false, cols: '12' },
    { field: 'value_max', type: 'number', required: false, cols: '12' },
    { field: 'value_min', type: 'number', required: false, cols: '12' },
    { field: 'value_selections', type: 'custom', required: false, cols: '12' },
    { field: 'default_value', type: 'custom', required: false, cols: '12' },
    { field: 'active', type: 'boolean', required: false, cols: '12' },
]

const generateEmptyForm = () => {
    return dataItems.reduce(
        (_form, item) => {
            _form[item.field] = null
            return _form
        },
        { id: 0 }
    )
}

import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

import SelectionValues from './SelectionValues.vue'
import DefaultValue from './DefaultValue.vue'
import ItemInventory from './ItemInventory.vue'
import MasterItemTypeAhead from '@/components/MasterItemTypeAhead'

const model = generateEmptyForm()
export default {
    name: 'MasterItems-viewItem',
    components: {
        SelectionValues,
        DefaultValue,
        ItemInventory,
        MasterItemTypeAhead,
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins],
    props: ['id'],
    data() {
        return {
            dataItems,
            componentName: 'Master Item',
            model,
            submitting: false,
            hasErrors: false,
            isView: false,
        }
    },

    computed: {
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        selectionOptions() {
            const { value_selections } = this.model
            try {
                return JSON.parse(value_selections)
            } catch (err) {
                return []
            }
        },
        title() {
            return this.isView
                ? 'Selected Item'
                : this.id
                ? 'Edit Item'
                : 'Add Item'
        },
        /*   item() {
            return this.$store.state.masterItem.item
        },
 */
        vendors() {
            return this.$store.state.assets.vendors
        },

        types() {
            return this.$store.state.itemType.items.filter(x => !x.is_discount)
        },
        is_product() {
            const { order_item_type_id } = this.model
            return !(this.types.find(x => x.id === order_item_type_id) || {})
                .is_task
        },
        validDataItems() {
            const { is_product } = this
            return this.dataItems.filter(x =>
                x.field === 'container_id' ? is_product : true
            )
        },
    },
    watch: {
        'model.order_item_type_id': function (id) {
            const type = this.types.find(x => x.id === id)
            console.log('type', type)
            if (type) model.uom = type.uom
        },
    },
    created() {
        this.isView = !!this.id
        this.$store.dispatch('locations/fetchWarehouses')
    },
    async mounted() {
        const { id } = this
        console.log('id', id)
        this.model = generateEmptyForm()
        if (id) {
            this.loadMasterItem(id)
        }
    },
    methods: {
        async loadMasterItem(id) {
            this.loading = true
            this.isView = true
            try {
                const _item = await this.$store.dispatch(
                    'masterItem/fetchByIdFunction',
                    id
                )
                for (const key in this.model) {
                    this.$set(this.model, key, _item[key])
                }
                const value_selections = _item.value_selections
                    ? JSON.parse(_item.value_selections)
                    : []

                this.$set(this.model, 'value_selections', value_selections)
            } catch (error) {
                console.error(error)
                this.isError = true
            } finally {
                this.loading = false
            }
        },

        checkVisibility(item) {
            switch (item.field) {
                case 'value_selections':
                    return !!this.model.is_selection_value_type
                case 'value_min':
                case 'value_max':
                    return !this.model.is_selection_value_type
                default:
                    return true
            }
        },
        getLabel(data) {
            if (data === 'order_item_type_id') return 'Type'
            if (data === 'container_id') return 'Bundled With'
            if (data === 'ext_reference_code') return 'Reference Code'
            const list = data.split('_')
            //remove last item if equal to id
            if (list[list.length - 1] === 'id') {
                list.pop()
            }

            return list
                .map(
                    x => x.slice(0, 1).toUpperCase() + x.slice(1).toLowerCase()
                )
                .join('  ')
        },
        getOptions(data) {
            const arr = (() => {
                switch (data) {
                    case 'vendor_id':
                        return this.vendors || []
                    case 'order_item_type_id':
                        return this.types || []
                }
            })()

            return arr.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },
        cancel() {
            this.$router.go(-1)
        },
        async deleteMasterItem() {
            // Initializing key variables
            const model = { ...this.model }
            const routes = {
                baseRoute: '/master-items',
                deleteRoute: 'masterItem/delete',
            }
            const notificationFields = {
                type: 'Master Item',
                errorMsg:
                    'Unable to delete Master Item, an association exists with other records',
            }

            await this.deleteItem(notificationFields, model, routes)
        },
        async onSubmit() {
            try {
                const valid = await this.$validator.validate()
                if (!valid) {
                    throw new Error('Form not Validated!')
                }
                //check default valye
                const payload = { ...this.model }
                console.log('payload', payload)
                const {
                    is_selection_value_type,
                    default_value,
                    value_max,
                    value_min,
                } = payload
                if (
                    !is_selection_value_type &&
                    !(
                        default_value == null &&
                        value_max == null &&
                        value_min == null
                    )
                ) {
                    console.log('value- before', default_value)
                    const value = parseFloat(default_value)
                    console.log('value-', value)
                    if (isNaN(value)) {
                        throw new Error('Invalid Default Value')
                    }
                    const max = parseFloat(value_max)
                    console.log('max', max)
                    if (!isNaN(max) && value > max) {
                        throw new Error('Max Value')
                    }

                    const min = parseFloat(value_min)
                    console.log('min', min)
                    if (!isNaN(min) && value < min) {
                        throw new Error('Invalid Min Value')
                    }
                }

                payload.value_selections = JSON.stringify(
                    payload.value_selections
                )

                payload.default_value = payload.default_value
                    ? payload.default_value.toString()
                    : null

                const isEdit = !!parseInt(payload.id)
                const path = `masterItem/${isEdit ? 'update' : 'create'}`

                this.submitting = true
                await this.$store.dispatch(path, payload)
                this.model = generateEmptyForm()
                const message = isEdit ? 'Updated' : 'Created'
                this.$emit('success', message)
                this.$router.go(-1)
            } catch (error) {
                const interror = 'Internal Server Error'
                if (interror == error.message) {
                    this.genericToast(
                        this.componentName,
                        'Duplicate',
                        'danger',
                        `The reference number provided is already in use. Please create a new Master Item`
                    )
                }
                // this.doToast('Error Detected', error.message, 'warning')
            } finally {
                this.submitting = false
            }
        },
    },
}
</script>
<style></style>
